// Validation for the national civil ID number collected on registration
// forms and staff-managed student/teacher records. Mirrors the server-side
// util (server/utils/nationalId.js) so the client shows the same Arabic
// error before a request is ever sent. A valid ID is EXACTLY nine numeric
// digits; no checksum is required.

export function normalizeNationalId(value) {
  return String(value == null ? '' : value).trim();
}

export function isValidNationalId(value) {
  const s = normalizeNationalId(value);
  return /^\d{9}$/.test(s);
}

// Returns an Arabic error message when the value is present but not a valid
// ID, or null when it is valid. Empty input is treated as valid here —
// callers decide separately whether the field is required.
export function nationalIdError(value) {
  const s = normalizeNationalId(value);
  if (s === '') return null;
  if (!/^\d{9}$/.test(s)) return 'رقم الهوية يجب أن يتكوّن من 9 أرقام فقط';
  return null;
}
